<template>
  <div>
    <common-dialog
      ref="dialog"
      width="650px"
      unit="联系方式"
      id-key="TradeUnitContactId"
      :data="data"
      :line-form="true"
      form-label-width="85px"
      :form-rules="rules"
      @opened="onOpened"
      @create-opened="onCreateOpened"
      @edit-opened="onEditOpened"
      @closed="onClosed"
      @close-saved="$emit('close-saved')"
    >
      <template slot="form">
        <el-row>
          <el-col :span="12">
            <el-form-item label="联系人" prop="Person">
              <el-input v-model="data.Person" placeholder="请输入名称" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="职位">
              <el-input v-model="data.Position" placeholder="请输入职位" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="联系电话" prop="Phone">
              <el-input
                type="number"
                v-int
                v-model.number="data.Phone"
                placeholder="请输入联系电话"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="地址">
              <el-input v-model="data.Address" placeholder="请输入地址" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="到货地址">
              <el-input
                v-model="data.ArrivalAddress"
                placeholder="请输入到货地址"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="邮箱" prop="Email">
              <el-input v-model="data.Email" placeholder="请输入邮箱" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="传真">
              <el-input v-model="data.Fax" placeholder="请输入传真" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="手机号" prop="Mobile">
              <el-input
                type="number"
                v-int
                v-model.number="data.Mobile"
                placeholder="请输入手机号"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="阴历生日">
              <el-date-picker
                class="payWay-item_picker"
                v-model="data.LunarBirthday"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                type="date"
                placeholder="选择日期"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="新历生日">
              <el-date-picker
                class="payWay-item_picker"
                v-model="data.Birthday"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                type="date"
                placeholder="选择日期"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="QQ号">
              <el-input
                type="number"
                v-int
                v-model.number="data.QQ"
                placeholder="请输入QQ号"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="MSN号">
              <el-input v-model="data.MSN" placeholder="请输入MSN号" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="微信号">
              <el-input v-model="data.Wechat" placeholder="请输入微信号" />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="序号">
              <el-input
                type="number"
                v-int
                v-model="data.Sn"
                style="width: 100px"
              ></el-input>
              <!-- <el-input-number v-model.number="data.Sn" :min="0" step-strictly style="width: 100px" ></el-input-number> -->
              <span class="t-tips">*值越小排得越前</span>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="状态">
              <el-radio-group v-model="data.IsDefault" class="detail-span">
                <el-radio :label="1">启用</el-radio>
                <el-radio :label="0">停用</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
      </template>
      <template slot="footer">
        <el-button type="primary" @click="toSave">保存</el-button>
        <el-button @click.stop="close">关 闭</el-button>
      </template>
    </common-dialog>
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";
export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
  },
  data() {
    return {
      data: {
        Person: "",
        Position: "",
        Phone: "",
        Address: "",
        ArrivalAddress: "",
        Email: "",
        Fax: "",
        Mobile: "",
        LunarBirthday: "",
        Birthday: "",
        QQ: "",
        MSN: "",
        Wechat: "",
        IsDefault: 1,
        Sn: null,
        TradeUnitId:0
      },
      // formApi: require("@/api/sy/formSetting").default,
      api: require("@/api/ba/tradeUnitContact").default,
      showList: [],
      rules: {
        Person: [{ required: true, message: "联系人" }],
        Mobile: [
          { required: false, message: "手机号不能为空" },
          { validator: this.$commonJs.validateRules.validPhone2 },
        ],
        Phone: [
          { required: true, message: "联系电话不能为空" },
          { validator: this.$commonJs.validateRules.validPhone2 },
        ],
        Email: [
          { required: false, message: "邮箱不能为空" },
          { validator: this.$commonJs.validateRules.validEmail },
        ],
        Sn: [{ required: true, message: "请输入序号" }],
      },
      tradeUnitId:0
    };
  },
  methods: {
    // 打开时获取显示显示列表
    onOpened() {
      this.data = {
        Person: "",
        Position: "",
        Phone: "",
        Address: "",
        ArrivalAddress: "",
        Email: "",
        Fax: "",
        Mobile: "",
        LunarBirthday: "",
        Birthday: "",
        QQ: "",
        MSN: "",
        Wechat: "",
        IsDefault: 1,
        Sn: null,
        TradeUnitId:this.tradeUnitId||0
      }
    },
    onEditOpened(data) {
      this.data = data;
      // console.log('edit data', this.data)
    },
    onCreateOpened() {
      this.api.getMaxSn().then((res) => {
        this.data.Sn = res;
      });
    },
    toSave() {
      this.$refs.dialog.formValidate().then((valid) => {
        if (!valid) return;

        console.log('save data json', JSON.parse(JSON.stringify(this.data)))
        console.log('save data', this.data)

        this.$emit("onSelect", this.data);
        this.close(true);
      });
    },
    onClosed() {
      this.showList = [];
    },
  },
};
</script>
